import { isBeekeeperFeatureEnabled } from '@lumapps/features';
import { isFormsEnabled } from '@lumapps/forms/ducks/selectors';
import { isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_SURVEYS } from '../constants';

export const isBeekeeperSurveysEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_SURVEYS);

/**
 * Determines if the current user has access to surveys feature.
 * Access rules:
 * - Must be a platform super admin (NOT site admin)
 * - Must have Forms enabled (Beekeeper integration + forms_management OR forms_lite)
 * - Must have BEEKEEPER_SURVEYS feature flag enabled
 */
export const hasBeekeeperSurveysAccess = createSelector(
    isSuperAdmin,
    isFormsEnabled,
    isBeekeeperSurveysEnabled,
    (platformAdmin, formsEnabled, surveysEnabled) => platformAdmin && formsEnabled && surveysEnabled,
);
